export default __webpack_public_path__ + "0d66d0eacc86d6735a051ab9a7f3bf93.png";